import { AutoComplete, Input } from 'antd';
import BaseLoader from 'components/atoms/base-loader';
import { type FC } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { isMobile } from 'utils/deviceHelper';
import { useAppSelector } from 'store';
import InputSearchIcon from 'components/atoms/icons/inputSearchIcon';

import s from './style.module.scss';
import { usePatientAutocomplete } from './hook';

import type { ModuleType } from 'infrastructure/enums';

interface Props {
  module: ModuleType;
  onChange: (patientGuid: string) => void;
}

const PatientAutocomplete: FC<Props> = ({ module, onChange }) => {
  const deviceType = useAppSelector((state) => state.user.deviceType);
  const {
    options,
    dataOptions,
    isLoading,
    searchKey,
    setSearchKey,
    searchValue,
    setSearchValue,
    debounceSearch,
    placeholder,
  } = usePatientAutocomplete({
    module,
  });

  return (
    <div className={s['inputs-wrapper']}>
      <div data-cy="patient-filter-list-dropdown">
        <BaseSelectBox
          options={options}
          allowClear={false}
          className={s.dropdown}
          onChange={(v) => {
            setSearchValue('');
            setSearchKey(v);
          }}
          value={searchKey}
        />
      </div>
      <div data-cy="patient-filter-input">
        <AutoComplete
          popupClassName="certain-category-search-dropdown"
          popupMatchSelectWidth
          style={{ width: isMobile(deviceType) ? undefined : 250 }}
          options={dataOptions ?? []}
          notFoundContent={
            isLoading ? (
              <BaseLoader loading={isLoading} height={20} width={20} />
            ) : (
              'No Data'
            )
          }
          onSelect={(value, option) => {
            setSearchValue(option.label);
            onChange(value);
          }}
          value={searchValue}
          optionRender={(option) => (
            <div data-cy="search-input-option">{option.label}</div>
          )}
        >
          <Input
            placeholder={placeholder}
            suffix={<InputSearchIcon />}
            className={s.search}
            onChange={(e) => {
              setSearchValue(e.target.value);
              debounceSearch({
                searchKey,
                searchValue: e.target.value,
              });
            }}
          />
        </AutoComplete>
      </div>
    </div>
  );
};

export default PatientAutocomplete;
